import { info } from '@xhs/logger';
import { commonChecks } from '@xhs/ozone-detector';
export function addMeasure(options) {
    if (process.env.BUILD_ENV !== 'production' || !commonChecks.isXHS)
        return;
    const ampOptions = {
        arg1: options.bridgeName,
        arg3: options.platformType,
    };
    if (options.isError) {
        // 上报错误调用INFO
        ampOptions.arg2 = `${options.errorInfo}`;
    }
    else {
        ampOptions.arg2 = `${options.timing}`;
    }
    info('custom-amp', ampOptions, options.isError ? 'bridge-error' : 'bridge-timing', {
        eaglet: true,
    });
}
